export default __webpack_public_path__ + "static/media/msat-instr-pink-vector.f66c1edc.svg";